import styled from 'styled-components';

export const OfferButton = styled.button`
  float: right;
  top: 0;
  position: fixed;
  right: 0%;
  z-index: 99999;
  border: none;
  background-color: transparent;
  cursor: pointer;
`;

export const OfferWrpBg = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  top: 0px;
  left: 0px;
  background-color: #9696967a;
`;

export const OfferWrp = styled.div`
  position: fixed;
  z-index: 999999;
  top: 0;
  background-color: #f5fdff;
  width: 100%;
  padding: 3rem;
  transition: all 0.5s ease 0s;
  &.topPos {
    top: -500px;
  }
  .closePos {
    margin-top: -1rem;
    padding-right: 9rem;
    position: absolute;
    right: 0;
    cursor: pointer;
    font-size: 40px;
    font-weight: 400;
  }
  .exclu {
    font-size: ${props => props.theme.font.custom(36)};
    font-family: ${props => props.theme.font.fontFamily};
    color: #555658;
  }
  .disc {
    font-size: ${props => props.theme.font.custom(32)};
    font-family: ${props => props.theme.font.fontFamily};
    color: #797a7b;
  }
  .offerRow {
    width: 70%;
    padding: 2rem 0;
  }
  .offer1 {
    border: 1px solid #c9dde3;
    border-radius: 5px;
    width: 45%;
  }
  .offerHd {
    background-color: #2980f7;
    padding: ${props => props.theme.spacing.custom(10)};
    color: #ffffff;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .offerHdOrg {
    background-color: #fd9460;
  }
  .flat {
    font-size: ${props => props.theme.font.custom(30)};
    font-family: ${props => props.theme.font.fontFamily};
  }
  .instant {
    font-size: ${props => props.theme.font.custom(18)};
    font-family: ${props => props.theme.font.fontFamily};
  }
  .offerBdy {
    background-color: #ffffff;
    padding: 10px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .offerType {
    font-size: ${props => props.theme.font.custom(16)};
    padding-bottom: 1rem;
  }
  .promoCopy {
    padding-bottom: 1rem;
  }
  .promoCode {
    border: 1px dashed #000;
    padding: 4px 10px;
    font-size: 14px;
    margin-right: 7px;
    color: #2980f7;
  }
  .copyCode {
    background-color: #272727;
    cursor: pointer;
    padding: 6px 10px;
    font-size: 12px;
    color: #ffffff;
    border-radius: 7px;
    text-transform: uppercase;
    &.selected {
      background-color: #939393;
    }
  }
  .minTrans {
    font-size: ${props => props.theme.font.custom(14)};
  }
`;

export const Offer1 = styled.div`
  border: 1px solid #c9dde3;
  border-radius: 5px;
  width: 45%;
`;

export const OfferHd = styled.div`
  background-color: #2980f7;
  padding: ${props => props.theme.spacing.custom(10)};
  color: #ffffff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

export const OfferHdOrg = styled(OfferHd)`
  background-color: #fd9460;
`;

export const Flat = styled.div`
  font-size: ${props => props.theme.font.custom(30)};
  font-family: ${props => props.theme.font.fontFamily};
`;

export const Instant = styled.div`
  font-size: ${props => props.theme.font.custom(18)};
  font-family: ${props => props.theme.font.fontFamily};
`;

export const OfferBdy = styled.div`
  background-color: #ffffff;
  padding: 10px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export const PromoCode = styled.div`
  border: 1px dashed #000;
  padding: 4px 10px;
  font-size: 14px;
  margin-right: 7px;
  color: #2980f7;
`;

export const CopyCode = styled.button`
  background-color: #272727;
  cursor: pointer;
  padding: 6px 10px;
  font-size: 12px;
  color: #ffffff;
  border-radius: 7px;
  text-transform: uppercase;
  &.selected {
    background-color: #939393;
  }
`;

export const Exclu = styled.div`
  font-size: ${props => props.theme.font.custom(36)};
  font-family: ${props => props.theme.font.fontFamily};
  color: #555658;
`;

export const Disc = styled.div`
  font-size: ${props => props.theme.font.custom(32)};
  font-family: ${props => props.theme.font.fontFamily};
  color: #797a7b;
`;

export const OfferRow = styled.div`
  width: 70%;
  padding: 2rem 0;
`;

export const OfferType = styled.div`
  font-size: ${props => props.theme.font.custom(16)};
  padding-bottom: 1rem;
`;

export const PromoCopy = styled.div`
  padding-bottom: 1rem;
`;
export const MinTrans = styled.div`
  font-size: ${props => props.theme.font.custom(14)};
`;

export const ClosePos = styled.div`
  margin-top: -1rem;
  padding-right: 9rem;
  position: absolute;
  right: 0;
  cursor: pointer;
`;
